import {Component} from "react";
import Chart from 'chart.js';
import 'chartjs-plugin-labels';

class Graph extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            array: this.props.graphData,
            chart: null,
         }
         this.config = {
            type: 'doughnut',
            data: {
                datasets: [{
                    data: this.state.array[1],
                    backgroundColor: this.state.array[2],
                }],
                labels: this.state.array[0]
            },
            options: {
                legend: { display: false },
                responsive: true,
                plugins: {
                   
                    labels:{
                        render: 'percentage',
                        precision: 0,
                        overlap: false,
                        fontSize: 13,
                        fontStyle: 600,
                        fontColor: '#fff',
                        fontFamily: 'Titillium Web'
                    },
                },
                tooltips: {
                    backgroundColor: 'rgba(84, 87, 114,.95)',
                    bodyFontFamily: 'Titillium Web',
                    bodyFontColor: '#fff',
                    bodyFontSize: 14,
                    bodyFontStyle: 400,
                    xPadding: 12,
                    yPadding: 12,
                    displayColors: false,
                    cornerRadius: 6,
                    caretSize: 6
                },
                cutoutPercentage: 50,
                elements: {
                    arc: {
                        borderWidth: 0
                    }
                },
            }
        };
    }

    componentDidMount(){
        let chart = new Chart(document.getElementById('myChart').getContext('2d'), this.config);
        this.setState({chart: chart});
    }

    render() { 
        
        return ( 
                <div className="exams-graph" >
                    <canvas id="myChart" width="50" height="50" />
                </div>
         );
    }
}
 
export default Graph;